var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotIconActive = function SvgHotspotIconActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "hotspot-icon-active_svg__Ebene_1",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".hotspot-icon-active_svg__st1{fill:#d6a444}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    style: {
      fillOpacity: 0.8
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9 0 0 9 0 20s9 20 20 20 20-9 20-20S31 0 20 0m0 38c-9.9 0-18-8.1-18-18S10.1 2 20 2s18 8.1 18 18-8.1 18-18 18",
    className: "hotspot-icon-active_svg__st1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 10,
    className: "hotspot-icon-active_svg__st1"
  })));
};
export { SvgHotspotIconActive as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA0MCA0MCI+CiAgPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI5LjQuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDIuMS4wIEJ1aWxkIDE1MikgIC0tPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuc3QwIHsKICAgICAgICBmaWxsLW9wYWNpdHk6IC44OwogICAgICB9CgogICAgICAuc3QxIHsKICAgICAgICBmaWxsOiAjZDZhNDQ0OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIyMCIgY3k9IjIwIiByPSIxOCIvPgogIDxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMCwwQzksMCwwLDksMCwyMHM5LDIwLDIwLDIwLDIwLTksMjAtMjBTMzEsMCwyMCwwWk0yMCwzOGMtOS45LDAtMTgtOC4xLTE4LTE4UzEwLjEsMiwyMCwyczE4LDguMSwxOCwxOC04LjEsMTgtMTgsMThaIi8+CiAgPGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iMjAiIGN5PSIyMCIgcj0iMTAiLz4KPC9zdmc+";